import axios from 'axios'
import { getCookie } from './Cookie'
import commonConfig from '../configs/common'
import { useAuthStore } from '../stores/UserAuth'
import { getSiteConfigByProfile } from '@/utils/SiteConfig'

// 创建axios实例
export const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL || '',
  timeout: 15000,
  headers: {
    'Content-Type': 'application/json'
  }
})

// 请求拦截器
api.interceptors.request.use(
  async config => {
      // 从cookie中获取token
      const token = getCookie(null, commonConfig.authTokenName)
      // 如果存在token，则添加到请求头
      if (token) {
        config.headers['token'] = `${token}`
      }
      const curLanguage = `${__SITE_PROFILE__}`
      const siteConfig = await getSiteConfigByProfile(curLanguage)
      const apiDomain = siteConfig.ApiDomainName
      // 移除URL开头的斜杠，避免重复
      const cleanUrl = config.url.replace(/^\/+/, '')
      // 移除域名中可能存在的尾部斜杠
      const cleanDomain = apiDomain.replace(/\/+$/, '')
      // 拼接完整的URL
      config.url = `${cleanDomain}/${cleanUrl}`
      return config
    },
    error => {
      return Promise.reject(error)
    }
)

// 响应拦截器
api.interceptors.response.use(
  response => {
    return response
  },
  async error => {
    const originalRequest = error.config

    // 如果是401错误（未授权）且没有重试过，尝试刷新token
    if (error.response && error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true

      try {
        // 客户端环境下才能刷新token
        if (typeof window !== 'undefined') {
          const authStore = useAuthStore()
          const newToken = await authStore.refreshToken()

          if (newToken) {
            // 更新请求头并重试
            originalRequest.headers.Authorization = `Bearer ${newToken}`
            return api(originalRequest)
          }
        }
      } catch (refreshError) {
        console.error('刷新token失败', refreshError)

        // 如果在客户端环境，清除认证状态
        if (typeof window !== 'undefined') {
          const authStore = useAuthStore()
          authStore.clearAuth()

          // 如果不是API请求，重定向到登录页
          // if (!originalRequest.url.startsWith('/api/')) {
          //   window.location.href = '/login'
          // }
        }
      }
    }

    return Promise.reject(error)
  }
)